export enum MessageStatus {
  Sending = "Sending",
  Sent = "Sent",
  Delivered = "Delivered",
  Failed = "Failed",
  None = "none (incoming)",
  Read = "Read",
}

export enum MESSAGE_CENTER_ACTIONS {
  ADD_NEW_PARTICIPANT = "participantJoined",
  REMOVE_PARTICIPANT = "participantLeft",
}

export const ROLE_TYPES = {
  CONVERSATION: "conversation",
  SERVICE: "service",
};

export const ROLE_NAMES = {
  CHANNEL_ADMIN: "channel admin",
  CHANNEL_USER: "channel user",
  PARTICIPANT: "participant",
  SERVICE_ADMIN: "service admin",
  SERVICE_USER: "service user",
};
